export const engageAgentRootPath = '/agent';
export const takeActionRootPath = '/take-action';
export const takeActionThreadMatchPath = '/take-action/thread/:threadId';

export const takeActionThreadUrl = (threadId: string): string => `/take-action/thread/${threadId}`;
